export enum DashboardTypes {
  PowerBi = 'PowerBi',
  Tableau = 'Tableau',
}
